import Container from "react-bootstrap/Container";
import NavbarC from "./NavbarC";
import styles from "../Assets/Scss/wrapper.module.scss";

const Wrapper = ({ children }) => {
  return (
    <Container fluid="true" className={styles.container}>
      <NavbarC />
      <Container fluid="true">{children}</Container>
    </Container>
  );
};
export default Wrapper;
